import request, { IServerResponse } from '@/utils/request';
import { PostDXAccountParams } from './define';

// 修改服务商接收售后消息大象账号
export const postDXAccount = (params: PostDXAccountParams): Promise<IServerResponse<string>> =>
    request.post('/api/serviceProvider/after/sale/dx/account', params);
